import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar";
import Sidebar from "../Sidebar/Sidebar";
import { AxiosResponse } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useParams } from 'react-router-dom';
import AdminSidebar from '../Sidebar/AdminSidebar';
import CostBreakdownEditor, { CostItem, emptyCostItem, costItemsTotal } from './CostBreakdownEditor';
import { convertUTCDateToLocalDate } from '../Reusable/functions';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaPen } from "react-icons/fa";
import { Oval } from 'react-loader-spinner';
import { MdDownload } from "react-icons/md";
import { VOUCHER_FILTER_STORAGE_KEY } from './VoucherFilterBar';



/**
 * FormData.append coerces null/undefined to the strings "null"/"undefined", which is
 * how vouchers ended up storing a literal 'null' in approved_amount and comment.
 * Everything posted or displayed goes through here.
 */
const clean = (value: any): string => {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  return (text === 'null' || text === 'undefined') ? '' : text;
};

const money = (value: any) => {
  const n = Number(clean(value));
  return isNaN(n) || clean(value) === '' ? '—' : `NGN ${n.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/**
 * The editable fields, reduced to a comparable string.
 *
 * Used to tell whether the form holds unsaved edits, so Approve/Reject can commit
 * them first. Only fields this page can actually change are included — anything else
 * would report the form dirty the moment the server echoed a value back differently.
 */
const signatureOf = (voucher: any, items: any[]): string => JSON.stringify({
  description_of_purpose: clean(voucher?.description_of_purpose),
  category_of_expenses: clean(voucher?.category_of_expenses),
  justification_of_request: clean(voucher?.justification_of_request),
  amount_requested: clean(voucher?.amount_requested),
  approved_amount: clean(voucher?.approved_amount),
  comment: clean(voucher?.comment),
  items: (items || []).map((i: any) => ({ name: String(i?.name ?? '').trim(), amount: String(i?.amount ?? '').trim() })),
});

function EditExpenseVoucher() {
  let [showScreen, setShowScreen] = React.useState<any>(1);

  const navigate = useNavigate();

  // What the voucher looked like when it was loaded or last saved.
  const pristineRef = React.useRef<string>('');

  const userLoginData = useSelector((state: any) => state.data.login.value);

  let [voucherData, setVoucherData] = React.useState<any>([]);

  // Itemised expenses. Seeded from the voucher once it loads; a voucher raised before
  // the breakdown was itemised has none, and its free text is shown instead.
  const [costItems, setCostItems] = React.useState<CostItem[]>([emptyCostItem()]);
  let [loader, setLoader] = React.useState<boolean>(false);
  let [loader2, setLoader2] = React.useState<boolean>(false);

  // ── Configurable approval chain ─────────────────────────────
  // Drives the approve/reject/resubmit actions and the timeline. The per-level
  // modals below are the legacy flow and stay only for older vouchers that were
  // raised before the chain existed.
  const [workflow, setWorkflow] = React.useState<any>(null);
  const [workflowAction, setWorkflowAction] = React.useState<'approve' | 'reject' | 'resubmit' | null>(null);
  const [actionComment, setActionComment] = React.useState('');
  const [actionAmount, setActionAmount] = React.useState('');
  const [actionLoading, setActionLoading] = React.useState(false);

  let [hodStatusModal, setHodStatusModal] = React.useState<boolean>(false);
  let [gmStatusModal, setGmStatusModal] = React.useState<boolean>(false);
  let [auditStatusModal, setAuditStatusModal] = React.useState<boolean>(false);
  let [groupheadStatusModal, setGroupheadStatusModal] = React.useState<boolean>(false);
  let [financeStatusModal, setFinanceStatusModal] = React.useState<boolean>(false);
  let [data, setData] = React.useState<any>([]);




  const [img1, setImg1] = React.useState('No selected file');
  const [img12, setImg12] = React.useState('empty');

  function uploadImg1(e: any) {
    let size = (e.target.files[0].size / 1048576.0)
    if (e.target.files && e.target.files[0]) {
      if (size > 4) {
        if (e.target.name == 'uploadImg1') {
          e.target.value = ''
          toast.warn('Image too large')
        }
      }
      if (size <= 4) {
        if (e.target.name == 'uploadImg1') {
          setImg1(e.target.files[0]);
          setImg12(URL.createObjectURL(e.target.files[0]))
        }
      }
    }
  };

  const params: any = useParams();
  let cusId: string = params?.id;


  React.useEffect(() => {
    SuperAdminApis.getSingleExpenseVoucher(cusId).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setVoucherData(response?.data?.data)
          setImg1(response?.data?.data?.supporting_document)

          // cost_items is cast to an array server-side, but a voucher stored before
          // that column existed returns null — fall back to one blank row and let the
          // editor show the old free text above it.
          const stored = response?.data?.data?.cost_items;
          const rows = Array.isArray(stored) ? stored : [];

          setCostItems(
            rows.length
              ? rows.map((item: any) => ({
                name: String(item?.name ?? ''),
                amount: item?.amount === null || item?.amount === undefined ? '' : String(item.amount),
              }))
              : [emptyCostItem()]
          );

          // Snapshot of the editable fields as loaded. Approve/Reject compares
          // against this to decide whether there are unsaved edits to commit first.
          pristineRef.current = signatureOf(response?.data?.data, rows.length
            ? rows.map((item: any) => ({
              name: String(item?.name ?? ''),
              amount: item?.amount === null || item?.amount === undefined ? '' : String(item.amount),
            }))
            : [emptyCostItem()]);

          // The block that used to sit here disabled Update Voucher for whole roles by
          // setting `loader` — the SUBMIT SPINNER flag — as a permission lock. It keyed
          // off hod_approval_status / audit_approval_status / ... , the hard-coded
          // columns the configurable chain stopped populating, so it locked people out
          // on rules that no longer describe the workflow and could never unlock them.
          // Who may act is decided by the chain (workflow.can_act); who may edit is
          // now everyone who can open the voucher.

        }
      }
    )
  }, []);



  const loadWorkflow = React.useCallback(() => {
    SuperAdminApis.getVoucherTimeline(Number(cusId))
      .then((response: any) => {
        if (response?.data?.status) setWorkflow(response.data.data);
      })
      .catch(() => {
        // Vouchers raised before the chain existed simply have no timeline.
      });
  }, [cusId]);

  React.useEffect(() => { loadWorkflow(); }, [loadWorkflow]);

  const openWorkflowAction = (action: 'approve' | 'reject' | 'resubmit') => {
    setActionComment('');
    setActionAmount(clean(voucherData?.approved_amount) || clean(voucherData?.amount_requested));
    setWorkflowAction(action);
  };

  const submitWorkflowAction = async (e: React.FormEvent) => {
    e.preventDefault();

    if (workflowAction === 'reject' && !actionComment.trim()) {
      toast.warn('Give a reason — the creator receives it by email');
      return;
    }

    setActionLoading(true);
    try {
      // Commit any unsaved edits BEFORE acting on the voucher.
      //
      // An approver who changes Amount Approved and presses Approve means "approve
      // this figure". Without this they would have had to press Update Voucher first
      // and remember the order, and forgetting silently approved the OLD amount —
      // the one case where a slip costs real money.
      //
      // Resubmit is excluded: the creator's own save already happened on that path,
      // and a failed save must not block returning a voucher to the chain.
      if (workflowAction !== 'resubmit' && isDirty()) {
        if (!await saveVoucher()) {
          // saveVoucher has already said why. Leave the dialog open so the edit is
          // not lost and the approver can correct it.
          setActionLoading(false);
          return;
        }
      }

      const id = Number(cusId);
      let response: any;

      if (workflowAction === 'approve') {
        response = await SuperAdminApis.approveVoucherStep(id, {
          comment: actionComment,
          approved_amount: currentStep?.is_disbursement ? actionAmount : undefined,
        });
      } else if (workflowAction === 'reject') {
        response = await SuperAdminApis.rejectVoucherStep(id, { comment: actionComment });
      } else {
        response = await SuperAdminApis.resubmitVoucher(id, { note: actionComment });
      }

      if (response?.data?.status) {
        toast.success(response.data.message);
        setWorkflowAction(null);
        loadWorkflow();
        SuperAdminApis.getSingleExpenseVoucher(cusId).then((r: AxiosResponse<any>) => {
          if (r?.data) {
            setVoucherData(r.data.data);
            // Re-baseline: what is on screen is what the server holds again.
            pristineRef.current = signatureOf(r.data.data, costItems);
          }
        });
      } else {
        toast.error(response?.data?.message || 'Action failed');
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Action failed');
    } finally {
      setActionLoading(false);
    }
  };

  const steps: any[] = workflow?.steps || [];
  const currentStep = steps.find((s: any) => s.position === workflow?.current_position);
  const canResubmit = workflow?.is_creator && workflow?.workflow_status === 'returned';

  const stepChip = (status: string) => {
    if (status === 'approved') return 'bg-green-100 text-green-700 border-green-200';
    if (status === 'rejected') return 'bg-red-100 text-red-700 border-red-200';
    return 'bg-amber-100 text-amber-700 border-amber-200';
  };

  function toggleFinanceStatus(data: any) {
    setData(data)
    setFinanceStatusModal(true)
  }

  function toggleHodStatus(data: any) {
    setData(data)
    setHodStatusModal(true)
  }

  function toggleAuditStatus(data: any) {
    setData(data)
    setAuditStatusModal(true)
  }

  function toggleGmStatus(data: any) {
    setData(data)
    setGmStatusModal(true)
  }

  function toggleGroupheadStatus(data: any) {
    setData(data)
    setGroupheadStatusModal(true)
  }





  const approveByHod = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveByHod(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);



  const rejectByHod = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByHod(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const approveByGrouphead = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveBygrouphead(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGroupheadStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const rejectByGrouphead = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByGrouphead(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setHodStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const approveByAudit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveByAudit(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setAuditStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const approveByGm = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.approveByGm(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGmStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const rejectByGm = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByGm(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setGmStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);

  const rejectByAudit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.rejectByAudit(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setAuditStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);


  const disburseByFinance = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);
    SuperAdminApis.disburseByFinance(data?.id)
      .then((response: any) => {
        if (response?.data) {
          if (response?.data?.status) {
            toast.success(response?.data?.message);
            setFinanceStatusModal(false)
            setTimeout(() => {
              refreshPage();
            }, 1000);
            SuperAdminApis.getSingleExpenseVoucher(cusId).then(
              (response: AxiosResponse<any>) => {
                if (response?.data) {
                  setVoucherData(response?.data?.data)
                  setImg1(response?.data?.data?.supporting_document)
                }
              }
            )
          }
          // console?.log(response?.data)
        }
      }).catch((err: any) => {
        console.log(err);
      })

  }, [voucherData, hodStatusModal, data, img1, loader]);





  let [statusModal, setStatusModal] = React.useState<boolean>(false);
  let [approveModal, setApproveModal] = React.useState<boolean>(false);

  const handleShipmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVoucherData({ ...voucherData, [e.target.name]: e.target.value });
  }


  /**
   * Persist the voucher. Returns true on success.
   *
   * Split out of the form handler so Approve and Reject can call it too: an approver
   * who edits Amount Approved and presses Approve expects that figure to be what gets
   * approved, not to have to press Update Voucher first and remember which order the
   * two buttons go in.
   *
   * Deliberately does NOT navigate. It used to bounce to the voucher list two seconds
   * after saving, which threw away the page an approver was still working on.
   */
  const saveVoucher = React.useCallback(async (): Promise<boolean> => {
    // Same rule as the create form. A legacy voucher is allowed through untouched —
    // its free text is preserved server-side — but once rows are being entered they
    // have to add up to something.
    const filledItems = costItems.filter((item) => item.name.trim() !== '' && item.amount !== '');
    const isLegacy = !Array.isArray(voucherData?.cost_items) || voucherData.cost_items.length === 0;
    const touched = costItems.some((item) => item.name.trim() !== '' || item.amount !== '');

    if ((!isLegacy || touched) && filledItems.length === 0) {
      toast.warn('Add at least one expense with a name and an amount');
      return false;
    }

    if (filledItems.length > 0 && costItemsTotal(filledItems) <= 0) {
      toast.warn('The expenses must total more than zero');
      return false;
    }

    setLoader(true);
    setLoader2(true);

    const formData = new FormData()
    formData.append('full_name', clean(voucherData?.full_name))
    formData.append('department', clean(voucherData?.department))
    formData.append('email', clean(voucherData?.email))
    formData.append('description_of_purpose', clean(voucherData?.description_of_purpose))
    formData.append('category_of_expenses', clean(voucherData?.category_of_expenses))
    formData.append('justification_of_request', clean(voucherData?.justification_of_request))
    formData.append('amount_requested', clean(voucherData?.amount_requested))
    formData.append('approved_amount', clean(voucherData?.approved_amount))
    // JSON because this form is multipart. The backend derives the readable
    // cost_breakdown text from these, and falls back to the stored text if none.
    formData.append('cost_items', JSON.stringify(
      costItems.filter((item) => item.name.trim() !== '' || item.amount !== '')
    ))
    formData.append('supporting_document', img1)
    formData.append('comment', clean(voucherData?.comment))
    formData.append('hod_email', clean(voucherData?.hod_email))
    formData.append('audit_email', clean(voucherData?.audit_email))
    formData.append('group_head_email', clean(voucherData?.group_head_email))
    formData.append('finance_email', clean(voucherData?.finance_email))
    formData.append('id', voucherData?.id)

    try {
      const response: any = await SuperAdminApis.updateVoucher(formData);

      if (response?.data?.status) {
        // The form is now what the server holds, so it is no longer dirty and a
        // following Approve will not save it a second time.
        pristineRef.current = signatureOf(voucherData, costItems);
        return true;
      }

      toast.error(response?.data?.message || 'Could not save the voucher');
      return false;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Could not save the voucher');
      return false;
    } finally {
      setLoader(false);
      setLoader2(false);
    }
  }, [voucherData, img1, costItems]);

  /** True when the form holds edits that have not been saved. */
  const isDirty = React.useCallback(
    () => pristineRef.current !== '' && pristineRef.current !== signatureOf(voucherData, costItems),
    [voucherData, costItems],
  );

  const updateExpenseVoucher = React.useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (await saveVoucher()) {
      toast.success('Voucher updated');

      // Reload in place rather than navigating away, so the approver keeps the page
      // and sees the saved figures alongside the approval chain.
      SuperAdminApis.getSingleExpenseVoucher(cusId).then((r: AxiosResponse<any>) => {
        if (r?.data) setVoucherData(r.data.data);
      });
      loadWorkflow();
    }
  }, [saveVoucher, cusId, loadWorkflow]);





  // console?.log(shipmentRider)
  const [searchText, setSearchText] = React.useState('');
  function refreshPage() {
    window.location.reload();
  }

  /**
   * Back to the list with the filter set the approver came in on.
   *
   * Rebuilt from the saved query string rather than navigate(-1): an approver who
   * opened this voucher from a link, an email, or a refresh has no list behind them,
   * and -1 would walk them out of the app.
   */
  const goBackToList = React.useCallback(() => {
    let query = '';

    try {
      query = sessionStorage.getItem(VOUCHER_FILTER_STORAGE_KEY) || '';
    } catch {
      // Storage unavailable — an unfiltered list is still the right destination.
    }

    navigate(`/admin/expense-voucher${query ? `?${query}` : ''}`);
  }, [navigate]);

  return (
    <>
      <AdminSidebar title="Expense Voucher" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title={`Expense Voucher (${voucherData?.voucher_id})`} />

        <div className="lg:px-10 px-6 pt-5">
          <button
            type="button"
            onClick={goBackToList}
            className="inline-flex items-center gap-2 rounded-[10px] border border-gray-200 bg-white px-3 py-[7px] text-[13px] font-medium text-gray-600 transition hover:border-[#E04343] hover:text-[#E04343]"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Back to vouchers
          </button>
        </div>

        <div>
          <form onSubmit={updateExpenseVoucher}>
            <div >
              <div className=' lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
                {/* <!-- Sender Information --> */}
                <div className="px-6 lg:mt-5 bg-white pt-[24px] rounded-[10px]">

                  <div>

                    <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto  mt-5">
                      <div className="relative flex flex-col min-w-0 break-words w-full  ">
                        <div className="flex-auto   py-10 pt-0">
                          <div className="flex flex-wrap ">

                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Full Name
                                </label>
                                <input
                                  type="text"
                                  disabled
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Name"
                                  name="full_name"
                                  defaultValue={voucherData?.full_name}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>



                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Department
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Phone Number"
                                  name="department"
                                  disabled
                                  defaultValue={voucherData?.department}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>



                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  E-Mail Address
                                </label>
                                <input
                                  type="email"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Company Email"
                                  name="email"
                                  disabled
                                  defaultValue={voucherData?.email}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>

                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Description Of Purpose
                                </label>
                                <textarea
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Purpose"
                                  defaultValue={voucherData?.description_of_purpose}
                                  name="description_of_purpose"
                                  onChange={(e: any) => handleShipmentChange(e)}
                                  required
                                />
                              </div>
                            </div>


                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Category Of Expenses
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder=""
                                  defaultValue={voucherData?.category_of_expenses}
                                  name="category_of_expenses"
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>


                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Justification Of Request
                                </label>
                                <textarea
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Request justification"
                                  name="justification_of_request"
                                  defaultValue={voucherData?.justification_of_request}
                                  onChange={(e: any) => handleShipmentChange(e)}
                                  required
                                />
                              </div>
                            </div>

                            <div className=" w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full ">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Supporting Document
                                </label>
                                <div className='flex justify-between'>
                                  <input id="dropzone-file" onChange={uploadImg1} accept="image/x-png,image/gif,image/jpeg" name='uploadImg1' type="file" className={" mb-2 text-sm text-[#6C757D] font-medium"} />

                                  {img1 == "no image" || !img1 ?
                                    ''
                                    :
                                    <a href={img1} target='_blank' className='text-[12px] mt-1 text-blue-500 underline'>
                                      View
                                      {/* <MdDownload size={17} /> */}
                                    </a>
                                  }

                                </div>

                              </div>
                              <span className="text-[10px] text-[#dc143c]">File should not be more than 4MB.</span>
                            </div>


                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Amount Requested
                                </label>
                                <input
                                  type="text"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="NG"
                                  name="amount_requested"
                                  defaultValue={voucherData?.amount_requested}
                                  onChange={handleShipmentChange}
                                  required
                                />
                              </div>
                            </div>


                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Amount Approved
                                </label>
                                {/* Open to anyone working the voucher. The figure releases
                                    money, so whoever last changed it is named underneath
                                    rather than the change being anonymous. */}
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Enter the approved amount"
                                  name="approved_amount"
                                  value={clean(voucherData?.approved_amount)}
                                  onChange={(e: any) => handleShipmentChange(e)}
                                />

                                {clean(voucherData?.approved_amount_by) ? (
                                  <p className="text-[11px] text-[#808080] mt-1">
                                    Set by {clean(voucherData?.approved_amount_by_name) || clean(voucherData?.approved_amount_by)}
                                    {clean(voucherData?.approved_amount_by_name) && (
                                      <span className="text-[#A0A0A0]"> ({clean(voucherData?.approved_amount_by)})</span>
                                    )}
                                    {voucherData?.approved_amount_at && (
                                      <span className="text-[#A0A0A0]"> · {convertUTCDateToLocalDate(voucherData.approved_amount_at)}</span>
                                    )}
                                  </p>
                                ) : (
                                  <p className="text-[11px] text-[#A0A0A0] mt-1">
                                    Not set yet. Whoever enters it will be recorded here.
                                  </p>
                                )}
                              </div>
                            </div>


                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <CostBreakdownEditor
                                items={costItems}
                                onChange={setCostItems}
                                amountRequested={voucherData?.amount_requested}
                                legacyText={
                                  Array.isArray(voucherData?.cost_items) && voucherData.cost_items.length
                                    ? null
                                    : voucherData?.cost_breakdown
                                }
                              />
                            </div>

                            {/* Vouchers on the configurable chain show their real
                                approvers in the Approval Chain panel below. The five
                                legacy email boxes are only kept for older vouchers
                                raised before the chain existed. */}
                            {steps.length > 0 ? (
                              <div className="w-full lg:w-12/12 lg:pr-4">
                                <div className="relative w-full bg-[#FAFAFA] border border-gray-200 rounded-[8px] p-3 mb-5">
                                  <p className="text-[12px] text-[#808080]">
                                    Approvers are set by the approval chain configured under
                                    <b> Administration → Voucher Settings</b>. See the Approval Chain below for who
                                    holds this voucher and what each level has said.
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="w-full lg:w-4/12 lg:pr-4">
                                  <div className="relative w-full">
                                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                      Head Of Department E-mail
                                    </label>
                                    <input
                                      type="text"
                                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                      placeholder=""
                                      disabled
                                      name="hod_email"
                                      defaultValue={voucherData?.hod_email}
                                      onChange={handleShipmentChange}
                                    />
                                  </div>
                                </div>

                                <div className="w-full lg:w-4/12 lg:pr-4">
                                  <div className="relative w-full">
                                    <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                      General Manager E-mail
                                    </label>
                                    <input
                                      type="text"
                                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                      placeholder=""
                                      disabled
                                      name="general_manager_email"
                                      defaultValue={voucherData?.general_manager_email}
                                      onChange={handleShipmentChange}
                                    />
                                  </div>
                                </div>

                                <div className="w-full lg:w-4/12 lg:pr-4">
                                  <div className="relative w-full">
                                    <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                      Audit Email
                                    </label>
                                    <input
                                      type="text"
                                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                      placeholder=""
                                      disabled
                                      name="audit_email"
                                      defaultValue={voucherData?.audit_email}
                                      onChange={handleShipmentChange}
                                    />
                                  </div>
                                </div>

                                <div className="w-full lg:w-4/12 lg:pr-4">
                                  <div className="relative w-full">
                                    <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                      Group Head Email
                                    </label>
                                    <input
                                      type="text"
                                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                      placeholder=""
                                      disabled
                                      name="group_head_email"
                                      defaultValue={voucherData?.group_head_email}
                                      onChange={handleShipmentChange}
                                    />
                                  </div>
                                </div>

                                <div className="w-full lg:w-4/12 lg:pr-4">
                                  <div className="relative w-full">
                                    <label className="block mb-2 text-[12px] font-semibold text-[#19213D]">
                                      Finance Email
                                    </label>
                                    <input
                                      type="text"
                                      className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                      placeholder=""
                                      disabled
                                      name="finance_email"
                                      defaultValue={voucherData?.finance_email}
                                      onChange={handleShipmentChange}
                                    />
                                  </div>
                                </div>
                              </>
                            )}


                            <div className="w-full lg:w-8/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Comments
                                </label>
                                {/* Optional: each level's comment now lives on the
                                    approval timeline, so this general note must not
                                    block an update. */}
                                <textarea
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3 placeholder:text-[#DADADA] placeholder:text-[12px]  ease-linear transition-all duration-150"
                                  placeholder="Optional note"
                                  name="comment"
                                  rows={5}
                                  defaultValue={clean(voucherData?.comment)}
                                  onChange={(e: any) => handleShipmentChange(e)}
                                />
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                {/* <!-- Receiver  Information --> */}


                {/* Approval chain — where the voucher is, who has acted, and why */}
                {steps.length > 0 && (
                  <div className='bg-[#FAFAFA] border border-gray-200 rounded-[10px] p-4 mt-8'>
                    <div className='flex flex-wrap justify-between items-center gap-2 mb-4'>
                      <h3 className='text-[14px] font-[700] text-[#19213D]'>Approval Chain</h3>
                      <span className={`text-[11px] px-2.5 py-1 rounded-full border ${workflow?.workflow_status === 'returned'
                        ? 'bg-red-50 text-red-700 border-red-200'
                        : workflow?.workflow_status === 'disbursed' || workflow?.workflow_status === 'approved'
                          ? 'bg-green-50 text-green-700 border-green-200'
                          : 'bg-blue-50 text-blue-700 border-blue-200'}`}>
                        {workflow?.workflow_status === 'returned'
                          ? 'Returned to creator for changes'
                          : workflow?.workflow_status === 'disbursed'
                            ? 'Disbursed'
                            : workflow?.workflow_status === 'approved'
                              ? 'Fully approved'
                              : `With ${workflow?.current_level || '—'}`}
                      </span>
                    </div>

                    <div className='space-y-3'>
                      {steps.map((step: any, index: number) => (
                        <div key={step.id} className={`flex gap-3 ${step.position === workflow?.current_position ? 'opacity-100' : 'opacity-90'}`}>
                          <div className='flex flex-col items-center'>
                            <span className={`w-6 h-6 rounded-full text-[11px] font-[700] flex items-center justify-center ${step.status === 'approved' ? 'bg-green-600 text-white'
                              : step.status === 'rejected' ? 'bg-red-600 text-white'
                                : step.position === workflow?.current_position ? 'bg-[#E04343] text-white' : 'bg-gray-300 text-white'}`}>
                              {index + 1}
                            </span>
                            {index < steps.length - 1 && <span className='flex-1 w-px bg-gray-300 my-1' />}
                          </div>

                          <div className='flex-1 pb-2'>
                            <div className='flex flex-wrap items-center gap-2'>
                              <p className='text-[13px] font-[600] text-[#19213D]'>{step.level_name}</p>
                              <span className={`text-[10px] px-2 py-0.5 rounded border ${stepChip(step.status)}`}>
                                {step.status}
                              </span>
                              {step.is_disbursement && (
                                <span className='text-[10px] px-2 py-0.5 rounded border bg-gray-100 text-gray-600 border-gray-200'>
                                  disburses
                                </span>
                              )}
                            </div>

                            <p className='text-[11px] text-[#808080] mt-0.5'>
                              {step.acted_by_email
                                ? `${step.acted_by_name || step.acted_by_email} · ${step.acted_at ? new Date(step.acted_at).toLocaleString('en-NG') : ''}`
                                : (step.approver_emails?.length
                                  ? `Awaiting: ${step.approver_emails.join(', ')}`
                                  : 'No approver assigned to this level')}
                            </p>

                            {step.comment && (
                              <p className='text-[12px] text-[#333333] bg-white border border-gray-200 rounded p-2 mt-1.5 whitespace-pre-line'>
                                {step.comment}
                              </p>
                            )}
                            {step.approved_amount && (
                              <p className='text-[11px] text-green-700 mt-1'>Approved amount: {step.approved_amount}</p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className='flex flex-wrap items-center justify-between gap-3 mt-6'>
                  {/* Repeated from the top of the page: by the time an approver has
                      scrolled to the Approve button they can no longer see the one up
                      there, and leaving is the other thing they do from here. */}
                  <button
                    type='button'
                    onClick={goBackToList}
                    className='inline-flex items-center gap-2 rounded-[40px] border border-gray-300 bg-white py-[5px] px-[20px] text-gray-600 transition hover:border-[#E04343] hover:text-[#E04343]'
                  >
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Back to vouchers
                  </button>

                  <div className='flex space-x-10'>
                    <div className='flex justify-between'>

                      <div className='flex gap-3 mr-5'>
                        {/* One pair of actions for whichever level currently holds the
                            voucher — replaces the five hard-coded role checks. */}
                        {workflow?.can_act && workflow?.workflow_status !== 'returned' && currentStep && (
                          <>
                            <button
                              type='button'
                              onClick={() => openWorkflowAction('approve')}
                              className='bg-green-600 hover:bg-green-700 rounded-[40px] py-[5px] px-[20px] text-white inline-flex'
                            >
                              Approve {currentStep.is_disbursement ? '& Disburse' : ''}
                            </button>
                            <button
                              type='button'
                              onClick={() => openWorkflowAction('reject')}
                              className='bg-[#E04343] hover:bg-[#c93a3a] rounded-[40px] py-[5px] px-[20px] text-white inline-flex'
                            >
                              Reject
                            </button>
                          </>
                        )}

                        {canResubmit && (
                          <button
                            type='button'
                            onClick={() => openWorkflowAction('resubmit')}
                            className='bg-[#19213D] hover:bg-[#2A3352] rounded-[40px] py-[5px] px-[20px] text-white inline-flex'
                          >
                            Resubmit for Approval
                          </button>
                        )}
                      </div>



                      <button
                        // onClick={() => setShowScreen(2)}
                        type='submit'
                        disabled={loader}
                        className={loader ? 'bg-[#808080] rounded-[40px] py-[5px] px-[20px] text-white inline-flex' : 'bg-[#E04343] rounded-[40px] py-[5px] px-[20px] text-white inline-flex'}  >
                        <div className="flex justify-center gap-3 ">
                          <span> Update Voucher</span>
                          <Oval
                            visible={loader2}
                            height="20"
                            width="20"
                            color="#E04343"
                            secondaryColor="#FCBF94"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                          />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>



              </div>
            </div>

            {/* <!-- Shipments  Information --> */}

          </form>
        </div>

      </div>

      {/* Approve / Reject / Resubmit for the configurable chain */}
      <section>
        <Modal
          visible={workflowAction !== null}
          width="480"
          height={workflowAction === 'approve' && currentStep?.is_disbursement ? '420' : '360'}
          effect="fadeInUp"
          onClickAway={() => setWorkflowAction(null)}
        >
          <div style={{ height: '100%', overflow: 'auto' }}>
            <div className='bg-white rounded-lg p-4'>
              <span className="flex justify-between px-1 pt-1">
                <p className='mt-1 font-bold'>
                  {workflowAction === 'approve' && `Approve at ${currentStep?.level_name}`}
                  {workflowAction === 'reject' && `Reject at ${currentStep?.level_name}`}
                  {workflowAction === 'resubmit' && 'Resubmit for approval'}
                </p>
                <p className="cursor-pointer font-bold" onClick={() => setWorkflowAction(null)}>
                  <SvgElement type={icontypesEnum.CANCEL} />
                </p>
              </span>

              <form onSubmit={submitWorkflowAction} className='pt-4'>
                {workflowAction === 'reject' && (
                  <p className='text-[12px] text-[#808080] bg-[#FAFAFA] border border-gray-200 rounded p-2 mb-3'>
                    {voucherData?.full_name || 'The creator'} is emailed this reason and can update the voucher and
                    resubmit it — it comes back to <b>{currentStep?.level_name}</b>.
                  </p>
                )}

                {workflowAction === 'resubmit' && (
                  <p className='text-[12px] text-[#808080] bg-[#FAFAFA] border border-gray-200 rounded p-2 mb-3'>
                    This goes back to <b>{steps.find((s: any) => s.status === 'rejected')?.level_name || 'the approver'}</b> who
                    asked for the change.
                  </p>
                )}

                {/* Unsaved edits are committed by this button. Said out loud, because
                    silently writing someone's half-finished form is worse than making
                    them press two buttons — they need to know it is about to happen. */}
                {workflowAction !== 'resubmit' && isDirty() && (
                  <div className='mb-4 bg-blue-50 border-l-4 border-blue-400 rounded-r px-3 py-2'>
                    <p className='text-[12.5px] text-blue-900'>
                      You have unsaved changes on this voucher
                      {clean(voucherData?.approved_amount) !== '' && (
                        <> — amount approved reads <b>{money(voucherData?.approved_amount)}</b></>
                      )}.
                      They will be saved first, then the voucher
                      {workflowAction === 'approve' ? ' approved' : ' rejected'}.
                    </p>
                  </div>
                )}

                {/* The disbursing level releases the money, so it sees the full picture
                    — what was asked for, what it is about to pay, and the difference —
                    before confirming. */}
                {workflowAction === 'approve' && currentStep?.is_disbursement && (() => {
                  const requested = Number(clean(voucherData?.amount_requested)) || 0;
                  const paying = Number(actionAmount) || 0;
                  const diff = paying - requested;

                  return (
                    <div className='mb-4'>
                      <div className='bg-[#FAFAFA] border border-gray-200 rounded-md p-3 mb-3'>
                        <div className='flex justify-between items-center text-[12.5px]'>
                          <span className='text-[#808080]'>Amount requested</span>
                          <span className='font-[600] text-[#19213D]'>{money(voucherData?.amount_requested)}</span>
                        </div>
                        <div className='flex justify-between items-center text-[12.5px] mt-1.5 pt-1.5 border-t'>
                          <span className='text-[#808080]'>You are disbursing</span>
                          <span className='font-[700] text-green-700'>{money(actionAmount)}</span>
                        </div>
                        {actionAmount !== '' && diff !== 0 && (
                          <p className={`text-[11px] mt-1.5 ${diff < 0 ? 'text-amber-700' : 'text-red-700'}`}>
                            {diff < 0
                              ? `${money(Math.abs(diff))} less than requested`
                              : `${money(diff)} more than requested`}
                          </p>
                        )}
                      </div>

                      <label className="block mb-2 text-[#333333] text-[12px]">
                        Amount to disburse <span className='text-red-600'>*</span>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={actionAmount}
                        onChange={(e) => setActionAmount(e.target.value)}
                        required
                        className="border border-gray-300 text-gray-700 text-sm rounded-md block w-full p-2"
                      />
                      <p className='text-[11px] text-[#808080] mt-1'>
                        Pre-filled with the requested amount — change it to release a different figure.
                        This becomes the voucher's approved amount.
                      </p>
                    </div>
                  );
                })()}

                <div className='mb-4'>
                  <label className="block mb-2 text-[#333333] text-[12px]">
                    {workflowAction === 'reject' ? 'Reason for rejection' : 'Note'}
                    {workflowAction === 'reject' && <span className='text-red-600'> *</span>}
                  </label>
                  <textarea
                    value={actionComment}
                    onChange={(e) => setActionComment(e.target.value)}
                    rows={4}
                    required={workflowAction === 'reject'}
                    placeholder={workflowAction === 'reject'
                      ? 'What needs to change before this can be approved?'
                      : 'Optional note kept on the voucher timeline'}
                    className="border border-gray-300 text-gray-700 text-sm rounded-md block w-full p-2"
                  />
                </div>

                <button
                  type="submit"
                  disabled={actionLoading}
                  className={`flex justify-center items-center gap-2 text-white rounded-[30px] w-full py-[10px] font-[700] text-[14px] disabled:opacity-60 ${workflowAction === 'reject' ? 'bg-[#E04343]' : workflowAction === 'approve' ? 'bg-green-600' : 'bg-[#19213D]'}`}
                >
                  <span>
                    {workflowAction === 'approve' && 'Confirm Approval'}
                    {workflowAction === 'reject' && 'Reject & Notify Creator'}
                    {workflowAction === 'resubmit' && 'Send for Approval'}
                  </span>
                  {actionLoading && <Oval visible height="16" width="16" color="#ffffff" secondaryColor="#cccccc" ariaLabel="saving" />}
                </button>
              </form>
            </div>
          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={hodStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setHodStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 font-bold'>Voucher Approval by HOD</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setHodStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg">
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByHod(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByHod(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={gmStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setGmStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by General Manager</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setGmStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByGm}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByGm(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByGm(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setAuditStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={auditStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setAuditStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Audit</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setAuditStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByAudit}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByAudit(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByAudit(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setAuditStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <section>
        <Modal
          visible={groupheadStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setGroupheadStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Group Head</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setGroupheadStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={approveByGrouphead}>
                  <div className="flex justify-between gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => approveByGrouphead(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Approve
                    </button>

                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => rejectByGrouphead(e)}
                      style={{ borderRadius: '50px', color: '#F52424' }}
                      className=" text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Reject
                    </button>


                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>


      <section>
        <Modal
          visible={financeStatusModal}
          width="350"
          height="400"
          effect="fadeInUp"
          onClickAway={() => setFinanceStatusModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>

            <div className="container  bg-[#fff] rounded-lg p-2">

              <div className="px-3">

                {/* <span className="flex justify-around">
                    <h1 className=" text-xs text-red-600" style={{ fontSize: '10px' }}>Link can’t be edited in free plan. <span style={{ color: '#61A24F' }} className="font-bold text-xs">Upgrade to Pro</span></h1>
                  </span> */}
                <span className="flex justify-between px-2 pt-3">
                  <p className='mt-2 text-[13px] font-bold'>Voucher Approval by Finance</p>
                  <p className="cursor-pointer font-bold" onClick={(e) => setFinanceStatusModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
                </span>

                <div className='my-10 text-[14px] text-gray-600'>
                  Please review the details of the voucher request below carefully before making your decision. Your action will determine the next steps in the approval process.
                </div>
                <form className="pb-4 rounded-lg" onSubmit={disburseByFinance}>
                  <div className="flex justify-center gap-2 pt-4">
                    <button
                      type="button"
                      disabled={loader}
                      onClick={(e: any) => disburseByFinance(e)}
                      style={{ borderRadius: '50px' }}
                      className=" text-green-700 bg-green-200 focus:ring-4 focus:outline-none focus:ring-grredeen-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center "
                    >
                      Disburse
                    </button>




                  </div>



                  <div >
                    {loader ?
                      <span className="flex justify-center pt-4">
                        <Oval
                          visible={true}
                          height="30"
                          width="30"
                          color="#F52424"
                          secondaryColor=""
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </span>
                      :
                      <span className="flex justify-center pt-4">
                        <button
                          type="button"
                          onClick={(e) => setHodStatusModal(false)}
                          style={{ borderRadius: '50px' }}
                          className=" text-black   focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center "
                        >
                          Cancel
                        </button>
                      </span>
                    }
                  </div>




                </form>
              </div>

            </div>

          </div>
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  )
}

export default EditExpenseVoucher